import * as React from 'react';

import './Header.scss';
import Navbar from './Navbar/Navbar';
import { Link } from 'react-router-dom';

class Header extends React.Component {
  public render() {
    const titleText = 'Erlebnis in der Region Villach';
    return (
      <header id="header">
        <div className="top full pd-f">
          <div className="container">
            <h1>{titleText}</h1>
            <Link to="/impressum">Impressum</Link>
            <img id="logo" src="/gfx/logo.png" />
          </div>
        </div>
        <Navbar />
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/layout/Header/Header.tsx